import React from 'react';
import PropTypes from 'prop-types';
import { MDash } from 'ui-components/components/mdash';
import { emptyArray } from 'ui-components/default-props/empty';
import {
  PackageContentDescriptionLabel,
  useShouldRequirePackageContentDescription,
} from '../../../fulfillment-planner/package-content-description';
import { LabeledRow } from '../../../fulfillment-planner/labeled-row';
import { ReadOnlyMessageForMultiPackageConfigs } from '../../../fulfillment-planner/package-content-description/read-only-message-for-multi-package-configs';

import style from './style.module.css';

const PackageContentDescriptionReadOnly = ({ packages = emptyArray }) => {
  const isPackageContentDescriptionRequired = useShouldRequirePackageContentDescription();
  if (!isPackageContentDescriptionRequired) {
    return null;
  }

  if (packages.length > 1) {
    return <ReadOnlyMessageForMultiPackageConfigs />;
  }
  // After a investigation about how packages could be empty in SPD-20854, there are cases where sellers set packages as null/none/empty
  // This could be done with automation rules or production mapping, so we need to handle this case  const packageContentDescription = isMultiPackage ? null : packages[0]?.contentDescription;
  const packageContentDescription = packages[0]?.contentDescription;

  return (
    <LabeledRow className={style.row} label={<PackageContentDescriptionLabel />} labelClassName={style.label}>
      {!packageContentDescription ? <MDash /> : packageContentDescription}
    </LabeledRow>
  );
};

PackageContentDescriptionReadOnly.propTypes = {
  packages: PropTypes.array,
};

export { PackageContentDescriptionReadOnly };
